export const INDICATOR_TYPES = new Set([
  'scope_change',
  'agent_change',
  'mode_change',
  'conversation_resumed',
  'new_conversation',
  'response_stopped',
  'message_failed',
]);
